export const billableQuantity = (total, free = 0) => Math.max(0, Number(total || 0) - Number(free || 0));

export function validPurchaseQuantities(lines, quantityField) {
    return (lines || []).every(line => {
        const total = Number(line[quantityField]);
        const free = Number(line.quantiteGratuite ?? 0);
        return Number.isFinite(total) && total > 0 && Number.isFinite(free) && free >= 0 && free <= total;
    });
}
